import { SplashScreenWrapper, SplashScreenLogo } from "./SplashScreen.styled";

export function SplashScreen() {
  return (
    <SplashScreenWrapper>
      <SplashScreenLogo />
    </SplashScreenWrapper>
  );
}
